import { PaymentType } from "./Enums";

export interface StationData {
  cashierGuid: string;
}

export interface ShiftBalanceModel {
    amount: number | null;
    currencyName: string;
    currencyId: number;
}

export interface CloseShiftPaymentsResponseModel {
    paymentType: PaymentType;
    amount: number;
    currencyId: number;
    createdAt: string;
    orderNumber: number;
    receiptId: number;
    customerFullName: string;
}

export interface CloseShiftResponseModel {
    numberOfOrders: number;
    qtyOfSoldTickets: number;
    startDateTime: string;
    openShiftUserFullName: string;

    groupedPayments: GroupedPaymentsModel[];
    groupedRefundedPayments: GroupedPaymentsModel[];
    shiftOpenBalancesCash: ShiftBalanceModel[];
    shiftCloseBalancesCash: ShiftBalanceModel[];
    shiftOpenBalancesCheck: ShiftBalanceModel[];
    shiftCloseBalancesCheck: ShiftBalanceModel[];
}

export interface GroupedPaymentDetailsModel {
    paymentType: PaymentType;
    transactionCount: number;
    totalAmount: number;
    createdAt: string;
    orderNumber: number;
    receiptId: number;
    customerFullName: string;
}

export interface GroupedPaymentsModel {
    currencyId: number;
    currencyName: string;
    payments: GroupedPaymentDetailsModel[];
    totalAmount: number;
}

export interface ShiftListResponseModel{
    shiftId: string;
    openDateTime: string;    
    closeDateTime: string;    
    openUserFullName: string;
    balanceDescription: string;    
    openShiftReportUrl: string;    
    closeShiftReportUrl: string;    
}

export class ShiftListFilter {
    keywords = "";
    startDate: Date | null = null;
    endDate: Date | null = null;
    pageIndex = 0;
    advancedSearch = false;
}

export class ShiftResponseModel {
    shiftId = "";
}